import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import { autoRehydrate } from 'redux-persist';
import reducer from '../reducers';

export default () => {
  const store = createStore(reducer, compose(
    applyMiddleware(thunk),
    autoRehydrate(),
  ));
  return store;
};



// WEBPACK FOOTER //
// ./src/store/store.prod.js